import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchVendors = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.VENDOR.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const fetchVendor = (payload) => {
  return axiosInstance.get(EndPoints.VENDOR.VENDOR_LIST_BY_ID + `/${payload}`);
}

export const createVendor = (payload) => {
  return axiosInstance.post(EndPoints.VENDOR.CREATE, payload)
}

export const updateVendor = (payload) => {
  return axiosInstance.put(EndPoints.VENDOR.UPDATE, payload)
}


export const deleteVendor = (payload) => {
  const url = EndPoints.VENDOR.DELETE + `/${payload}`
  return axiosInstance.delete(url)
}

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.VENDOR.DOWNLOAD_CSV, {
    responseType: 'blob'
  });
}
